import { gql } from 'apollo-angular';

/**
 * Options schema
 */
export class OptionsSchema {
	static readonly getTimezoneList = gql`
		query GetTimeZoneList {
			getTimeZoneList {
				id
				displayName
			}
		}
	`;

	static readonly getEnum = gql`
		query enumValuesOfMetaInformationTags($enumName: String!) {
			__type(name: $enumName) {
				name
				enumValues {
					name
				}
			}
		}
	`;
}
